
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/campaigns",
      function () {
        return require("private-next-pages/lifecycle-studio/campaigns.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/campaigns"])
      });
    }
  